import { type FC } from 'react';
import {
  HourglassHigh
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconHourglassHighProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconHourglassHigh: FC<UiIconHourglassHighProps> = (props) => {
  return (
    <UiIcon
      IconComponent={HourglassHigh}
      {...props}
    />
  );
};
